import { render, staticRenderFns } from "./vastuuhenkilo.vue?vue&type=template&id=a44590e2&scoped=true&"
import script from "./vastuuhenkilo.vue?vue&type=script&lang=ts&"
export * from "./vastuuhenkilo.vue?vue&type=script&lang=ts&"
import style0 from "./vastuuhenkilo.vue?vue&type=style&index=0&id=a44590e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44590e2",
  null
  
)

export default component.exports